<template>
  <div>
    <p class="text-sm text-italic">
      Bila ingin menambah treatment silahkan kontak admin pusat <a href="#">disini</a>
    </p>

    <input 
      type="text" 
      v-model="searchQuery" 
      placeholder="Cari treatment..." 
      @input="searchTreatment" 
      class="form-control mb-3"
    />

    <div class="row gx-3" v-if="treatments.length > 0">
      <Card v-for="treatment in treatments" 
      :key="treatment.id" 
      :data="treatment"
      @showDetail="openTreatmentDetail" />
    </div>

    <p class="text-center text-sm" v-if="treatments.length == 0">Tidak ada treatment</p>

    <p class="text-center text-sm" v-if="!searchQuery && treatmentCurrentPage < treatmentTotalPage">
      <a class="color-gray-100" @click="getTreatment(treatmentCurrentPage + 1)">
        Muat lebih banyak <span class="icon-ico-chev-down"></span>
      </a>
    </p>

    <div class="row gx-3 mt-4" v-if="ingredients.length > 0">
      <h4 class="mb-2">Bahan Baku yang Digunakan</h4>
      <ul>
        <li v-for="ingredient in ingredients" :key="ingredient.id">
          {{ ingredient.name }} ({{ ingredient.code }})
        </li>
      </ul>
    </div>

    <div class="overlay-popup">
      <ModalDetail :data="treatmentDetail" v-if="treatmentDetail"/>
      <ModalPengajuan :data="treatmentDetail" v-if="treatmentDetail"/>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue'
import ModalDetail from './ModalDetail.vue'
import ModalPengajuan from './ModalPengajuan.vue'
import axios from 'axios';

export default {
  components: {
    Card,
    ModalDetail,
    ModalPengajuan
  },
  data() {
    return {
      treatments: [],
      ingredients: [],
      searchQuery: '',
      treatmentCurrentPage: 1,
      treatmentTotalPage: 1,
      treatmentLimit: 10,
      treatmentSortby: 'id.desc',
      treatmentDetail: null
    }
  },
  methods: {
    openTreatmentDetail(treatment) {
    this.treatmentDetail = treatment;
  },
    async getTreatment(page = 1) {
      try {
        const response = await axios.get('/treatments', {
          params: {
            kfsId: this.$route.params.id,
            page: page,
            limit: this.treatmentLimit,
            sortBy: this.treatmentSortby
          }
        });

        const data = response.data.data;
        console.log('✅ Treatment API Response:', data);

        if (page === 1) {
          this.treatments = data.rows;
        } else if (data.rows.length > 0) {
          this.treatments = [...this.treatments, ...data.rows];
        }

        this.treatmentCurrentPage = data.currentPage;
        this.treatmentTotalPage = data.totalPages;

        if (this.treatments.length > 0) {
          this.treatments.forEach(treatment => {
            this.getAccuTreatmentMaterials(treatment.accu_treatment_id);
          });
        }
      } catch (error) {
        console.error('❌ Error fetching treatments:', error);
      }
    },

    async getAccuTreatmentMaterials(accu_treatment_id) {
      if (!accu_treatment_id || isNaN(Number(accu_treatment_id))) {
        console.warn("⚠️ Invalid accu_treatment_id, skipping request.");
        return;
      }

      try {
        const response = await axios.get('/kfs-inventory/ingredients/by-treatment', {
          params: { 'where[accuTreatmentId]': Number(accu_treatment_id) }
        });

        console.log(`✅ Response Data:`, response.data);
        this.ingredients = response.data.rows || [];

      } catch (error) {
        console.error(`❌ Error fetching materials for Treatment ID ${accu_treatment_id}:`, error);
        if (error.response) {
          console.error("🔍 Server Response:", error.response.data);
        }
      }
    },

    async getRawMaterials(rawMaterialIds, accuTreatmentId) {

      if (rawMaterialIds.length === 0) {
        console.warn('⚠️ No raw material IDs found, skipping raw material fetch.');
        return;
      }

      try {
        const response = await axios.get('/kfs-inventory/accu-raw-materials', {
          params: { 'where[id]': rawMaterialIds }
        });

        const treatmentIndex = this.treatments.findIndex(t => t.accu_treatment_id === accu_treatment_id);
        if (treatmentIndex !== -1) {
          this.treatments[treatmentIndex].ingredients = response.data.data || [];
        }

        this.validateMaterials(accuTreatmentId);
      } catch (error) {
        console.error('❌ Error fetching raw materials:', error);
      }
    },

    validateMaterials(accuTreatmentId) {

      const treatment = this.treatments.find(t => t.accu_treatment_id === accuTreatmentId);
      if (!treatment) {
        console.warn(`⚠️ Treatment ID ${accuTreatmentId} not found in treatments list.`);
        return;
      }


      const treatmentMaterials = this.ingredients.map(ing => ing.id);

      if (treatmentMaterials.length === 0) {
        console.warn(`⚠️ Treatment ID ${accuTreatmentId} has no assigned materials.`);
      } else {
        console.log(`✅ Treatment ID ${accuTreatmentId} has valid materials.`);
      }
    },

    async searchTreatment() {

      if (!this.searchQuery) {
        this.getTreatment(1);
        return;
      }

      try {
        const response = await axios.get('/treatments', {
          params: {
            kfsId: this.$route.params.id,
            search: this.searchQuery,
            limit: this.treatmentLimit,
            sortBy: this.treatmentSortby
          }
        });

        console.log('🔎 Search API Response:', response.data);
        this.treatments = response.data.data.rows;

        if (this.treatments.length > 0) {
          this.treatments.forEach(treatment => {
            this.getAccuTreatmentMaterials(treatment.accu_treatment_id);
          });
        }
      } catch (error) {
        console.error('❌ Error searching treatments:', error);
      }
    }
  },
  mounted() {
    this.getTreatment();
  }
}
</script>
